import { defineMessages } from "react-intl";

export const messages = defineMessages({
  update: {
    id: "ari.management.updateForm.update",
    defaultMessage: "Update"
  },
  cancel: {
    id: "ari.management.updateForm.cancel",
    defaultMessage: "Cancel"
  },
  updating: {
    id: "ari.management.updateForm.updating",
    defaultMessage: "Updating"
  }
});